import { Link, Text } from '@nerdwallet/currency';
import P from 'prop-types';
import nds from '@nerdwallet/base-styles/classes';
import classNames from 'classnames';
import styles from './keto-product-card.module.scss';

const WhyThisProduct = ({
  whyThisProductTypeOverride,
  productName,
  whyThisProductText,
  whyThisProductMethodologyUrl,
}) => (
  <div
    className={classNames([styles['why-this-product'], nds('margin-bottom-2')])}
  >
    <Text size="small" component="h4">
      Why this {whyThisProductTypeOverride || productName || 'product'} made the
      list
    </Text>
    <Text component="p">{whyThisProductText}</Text>
    <Link target="_blank" href={whyThisProductMethodologyUrl}>
      Read our methodology
    </Link>
  </div>
);

WhyThisProduct.propTypes = {
  whyThisProductTypeOverride: P.string,
  productName: P.string,
  whyThisProductText: P.string,
  whyThisProductMethodologyUrl: P.string,
};

export default WhyThisProduct;
